module.exports = __webpack_public_path__ + "img/lv3_3_1.bb19e42b.png";